import React, { useDebugValue, useEffect, useState } from 'react'
import { fetchPermissions, upsertPermission } from '../../services/Administracion/permissionService';
import { fetchMenuOptions } from '../../services/Administracion/menuOptionsService';
import { Permission } from '../../types/permission';
import { MenuOption } from '../../types/menuOption';
import PermissionModal from '../Administracion/PermissionModal';
import { useAuth } from '../../context/AuthContext';

const PermissionList: React.FC = () => {
    const { user } = useAuth();
    const [permissions, setPermissions] = useState<Permission[]>([]);
    const [menuOptions, setMenuOptions] = useState<MenuOption[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [selectedPermission, setSelectedPermission] = useState<Permission | null>(null);
    const [showModal, setShowModal] = useState<boolean>(false);

    const loadData = async () => {
        setLoading(true);
        setError(null);
        try {
            const [permisos, menues] = await Promise.all([fetchPermissions(), fetchMenuOptions()]);
            setPermissions(permisos);
            setMenuOptions(menues.filter(m => m.is_active));
        } catch (error: any) {
            setError(error.message || 'Error al cargar datos');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const handleCreateEditPermission = (permission?: Permission) => {
        setSelectedPermission(permission || null);
        setShowModal(true);
    };


    const handleSavePermission = async (permission: Permission) => {
        //console.log('Permiso por guardar en handleSavePermission: ', permission);
        try {
            permission.created_by = user?.User.email

            await upsertPermission(permission);
            loadData();
        } catch (error: any) {
            setError(error.message || 'Error al guardar al permiso');
        }
        setShowModal(false);
    }

    if (loading) return <div>Cargando permisos...</div>;
    if (error) return <div className="text-danger">Error: {error}</div>;

    return (
        <div className="container mt-4">
            <h4>Lista de Permisos</h4>
            <div className='mb-3 text-end'>
                <button
                    className="btn btn-primary mb-3"
                    onClick={() => handleCreateEditPermission()}
                >
                    Crar Permiso
                </button>
            </div>
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th>Menú</th>
                        <th>ID</th>
                        <th>Nombre del Permiso</th>
                        <th>Descripción</th>
                        <th>Activo</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {permissions.map((permiso) => {
                        const menuOption = menuOptions.find(m => m.menu_id === permiso.menu_id);
                        return (
                            <tr key={permiso.permission_id}>
                                <td>{menuOption?.menu_name} - {(permiso.menu_id)}</td>
                                <td>{permiso.permission_id}</td>
                                <td>{permiso.permission_name}</td>
                                {/* <td>{permiso.menu_id}</td> */}
                                <td>{permiso.description}</td>
                                <td>{permiso.is_active ? 'Si' : 'No'}</td>
                                <td>
                                    <button
                                        className="btn btn-sm btn-secondary"
                                        onClick={() => handleCreateEditPermission(permiso)}
                                    >
                                        Editar
                                    </button>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {showModal && (
                <PermissionModal
                    permission={selectedPermission}
                    menuOptions={menuOptions}
                    onClose={() => setShowModal(false)}
                    onSave={handleSavePermission}
                />
            )}
        </div>
    )
};

export default PermissionList;
